/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const widget_ios = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 7.614a.933.933 0 0 1-.273.66l-6.454 6.453a.933.933 0 0 1-1.32 0l-5.68-5.679a.934.934 0 0 1 0-1.32l2.06-2.06a2.333 2.333 0 1 1 2.334-2.334l2.06-2.06a.933.933 0 0 1 1.32 0l1.31 1.313a2.334 2.334 0 1 0 3.056 3.057l1.314 1.31a.933.933 0 0 1 .273.66Z"
    />
  </svg>
)
export default widget_ios
